import { Component } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';

import { InternationalizationService } from './services/utils/Internationalization.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    title = 'TGStaff';

    constructor(internationalizationService: InternationalizationService,
                translateService: TranslateService) {
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);

        const language = internationalizationService.getLanguage();

        moment.locale(language);
        translateService.setDefaultLang(language);
        translateService.use(language);
    }
}
